import { useEffect } from 'react'

import { useQuery } from 'react-query'
import { useNavigate, useParams } from 'react-router'
import { Link } from 'react-router-dom'

import { CreatorHeroLogo } from '@/components/layout/header/logo.tsx'
import { Button } from '@/components/ui/button.tsx'
import { Card, CardContent, CardTitle } from '@/components/ui/card.tsx'
import { Skeleton } from '@/components/ui/skeleton.tsx'
import { useAccount } from '@/modules/accounts/hooks/useAccounts'
import { passwordService } from '@/modules/accounts/service/password-service.ts'
import { ResetPassword } from '@/modules/accounts/ui/ResetPassword'
import { ResetPasswordMail } from '@/modules/accounts/ui/ResetPasswordMail'
import { AppRoutes } from '@/utils/constants'
import { classNames } from '@/utils/helpers'
import { useIsDarkTheme } from '@/utils/useTheme'

export const ResetPasswordPage = () => {
  const { isLoggedIn } = useAccount()

  const isDarkMode = useIsDarkTheme()

  const navigate = useNavigate()

  const { token } = useParams()

  const tokenQuery = useQuery(
    ['reset-password'],
    async () => {
      if (token) return await passwordService.isValidPasswordResetToken(token)
    },
    {},
  )

  useEffect(() => {
    if (isLoggedIn) {
      navigate(AppRoutes.Overview.asUrl())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn])

  const errorState = () => {
    return (
      <Card className="flex w-full max-w-xl flex-col gap-6 p-8">
        <CardTitle className="flex flex-col items-center justify-center gap-4">
          <CreatorHeroLogo width={215} />
        </CardTitle>
        <CardContent className="grid gap-6 p-0">
          <p className="text-center">
            Oops, your token is invalid or there was an error.
          </p>
          <Button className="w-full">
            <Link
              to={AppRoutes.Auth.ResetPassword.asUrl()}
              // Refreshes page and outcomes errorState

              onClick={() =>
                (window.location.href = AppRoutes.Auth.ResetPassword.asUrl())
              }
            >
              Go back
            </Link>
          </Button>
        </CardContent>
      </Card>
    )
  }

  return (
    <div
      className={classNames(
        "grid h-screen w-screen place-items-center bg-[url('/login-background.webp')] bg-cover bg-no-repeat",
        {
          "bg-[url('/login-background-dark.png')]": isDarkMode,
        },
      )}
    >
      {tokenQuery.isError ? (
        errorState()
      ) : (
        <Card className="flex w-full max-w-xl flex-col gap-6 p-8">
          <CardTitle className="flex flex-col items-center justify-center gap-4">
            <CreatorHeroLogo width={215} />
            <div className=" text-sm font-normal text-secondary-300">
              {token && tokenQuery.isSuccess ? (
                <>Please enter your new password</>
              ) : (
                <>Enter your CreatorHero E-Mail to reset your password</>
              )}
            </div>
          </CardTitle>
          <CardContent className="p-0">
            {tokenQuery.isFetching ? (
              <Skeleton className="h-52 w-full" />
            ) : token && tokenQuery.isSuccess ? (
              <ResetPassword token={token} />
            ) : (
              <ResetPasswordMail />
            )}
          </CardContent>
        </Card>
      )}
    </div>
  )
}
